import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
// import { redeem_orderApi } from "../../app/slices/redeemSlice";
import DateSearchComponent from "../../components/customTable/DateSearchComponent";
import { Box, Button, IconButton, Tooltip } from "@mui/material";
import { toast } from "react-toastify";
import { ContentCopy } from "@mui/icons-material";

import { redeemQuoteApi } from "../../app/slices/redeems/redeemQuoteSlice";
import useFilterHandler from "../../components/filterhandler";
import Loader from "../digitalGold/Loader";
import Filter from "../../components/Filter";


export default function RedeemQuote() {
  const dispatch = useDispatch();
  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  });
  const handleSearch = (startDate, endDate) => {
    setQueryParams({ startDate, endDate });
  };
  useEffect(() => {
    dispatch(redeemQuoteApi(queryParams));
  }, [dispatch, queryParams]);

  const sliceResponse = useSelector(
    (state) => state.redeemQuote.redeemQuote.data
  );
  console.log("sliceResponse: ", sliceResponse);
  const stateLoading = useSelector(
    (state) => state.redeemQuote.loading
  );

//  const [filterData, setFilterData] = useState({
//         startDate: "",
//         endDate: "",
//         metalType:"",
     
//         name: "",
//         orderId:"",
        
//       transactionId: "",
//       merchantTransactionId:"",
//       pgorderId:"",
//         customerRefNo: "",
       
//       });
    
//         const url = `/api/admin/augmont-redeem/list`
      
//         const { handleFilterSubmit, handleClearFilters, loader, results, apiCall,message,error,toastTrigger } = useFilterHandler(url, filterData, setFilterData)


//         useEffect(() => {
//     apiCall(false)
//   }, []);

//    useEffect(() => {
//   if (!message) return;

//   console.log("Message updated:", message);

//   if (error) {
//     toast.error(message);
//   }
  
//   // else {
//   //   // toast.success(message);
//   // }
// }, [toastTrigger]);

  const columnHelper = createMRTColumnHelper();
  const columns = [
    // columnHelper.accessor("_id", {
    //   header: "ID",
    //   size: 30,
    //   Cell: ({ cell }) => {
    //     const handleCopy = () => {
    //       navigator.clipboard.writeText(cell.row.original?._id);
    //       toast.success("copied to clipboard!");
    //     };
    //     return (
    //       <Tooltip title={cell.row.original?._id}>
    //         <IconButton onClick={handleCopy}>
    //           <ContentCopy />
    //         </IconButton>
    //       </Tooltip>
    //     );
    //   },
    // }),
    columnHelper.accessor("customerRefNo", {
      header: "Customer Ref No",
      size: 200,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.customerRefNo);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.customerRefNo}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.customerRefNo || "N/A"}
            </span>
          </Tooltip>
        );
      },
    }),
     columnHelper.accessor("customerName", {
      header: "Name",
      size: 100,
      Cell: (cell) => cell.row.original?.customerName,
    }),

    //  columnHelper.accessor("mobileNo", {
    //   header: "Phone",
    //   size: 100,
    //   Cell: (cell) => cell.row.original?.mobileNumber,
    // }),

    //  columnHelper.accessor("partner_id", {
    //   header: "Paartner Id",
    //   size: 200,
    //   Cell: ({ cell }) => {
    //     const handleCopy = () => {
    //       navigator.clipboard.writeText(cell.row.original?.partner_id);
    //       toast.success("copied to clipboard!");
    //     };
    //     return (
    //       <Tooltip title={cell.row.original?.partner_id}>
    //         <span>
    //           <IconButton onClick={handleCopy}>
    //             <ContentCopy />
    //           </IconButton>
    //           {cell.row.original?.partner_id}
    //         </span>
    //       </Tooltip>
    //     );
    //   },
    // }),
    // columnHelper.accessor("partner_username", {
    //   header: "Partner Username",
    //   size: 100,
    //   Cell: (cell) => cell.row.original?.partner_username,
    // }),
   
    // columnHelper.accessor("message", {
    //   header: "Message",
    //   size: 100,
    //   Cell: (cell) => cell.row.original?.message,
    // }),

    //  columnHelper.accessor("redeemWeight", {
    //   header: "Redeem Weight",
    //   size: 100,
    //   Cell: (cell) => cell.row.original?.redeemWeight,
    // }),
    // columnHelper.accessor("status", {
    //   header: "Status",
    //   size: 100,
    //   Cell: (cell) => cell.row.original?.status,
    // }),

    // columnHelper.accessor("awbNo", {
    //   header: "awbNo",
    //   size: 200,
    //   Cell: ({ cell }) => {
    //     const handleCopy = () => {
    //       navigator.clipboard.writeText(cell.row.original?.awbNo);
    //       toast.success("copied to clipboard!");
    //     };
    //     return (
    //       <Tooltip title={cell.row.original?.awbNo}>
    //         <span>
    //           <IconButton onClick={handleCopy}>
    //             <ContentCopy />
    //           </IconButton>
    //           {cell.row.original?.awbNo}
    //         </span>
    //       </Tooltip>
    //     );
    //   },
    // }),
    // columnHelper.accessor("logisticName", {
    //   header: "Logistic Name",
    //   size: 100,
    //   Cell: (cell) => cell.row.original?.logisticName,
    // }),
    columnHelper.accessor("merchantTransactionId", {
      header: "Merchant Transaction ID",
      size: 200,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(
            cell.row.original?.merchantTransactionId
          );
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.merchantTransactionId}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.merchantTransactionId}
            </span>
          </Tooltip>
        );
      },
    }),

    // columnHelper.accessor("orderId", {
    //   header: "Order ID",
    //   size: 150,
    //   Cell: ({ cell }) => {
    //     const handleCopy = () => {
    //       navigator.clipboard.writeText(cell.row.original?.orderId);
    //       toast.success("copied to clipboard!");
    //     };
    //     return (
    //       <Tooltip title={cell.row.original?.orderId}>
    //         <span>
    //           <IconButton onClick={handleCopy}>
    //             <ContentCopy />
    //           </IconButton>
    //           {cell.row.original?.orderId}
    //         </span>
    //       </Tooltip>
        
    //     );
    //   },
    // }),
    // columnHelper.accessor("metalType", {
    //   header: "Metal Type",
    //   size: 100,
    //   Cell: (cell) => cell.row.original?.metalType,
    // }),

    // columnHelper.accessor("quantity", {
    //   header: "Quantity",
    //   size: 100,
    //   Cell: (cell) => cell.row.original?.quantity,
    // }),
    // columnHelper.accessor("goldBalance", {
    //   header: "Gold Balance",
    //   size: 100,
    //   Cell: (cell) => cell.row.original?.goldBalance,
    // }),
    // columnHelper.accessor("silverBalance", {
    //   header: "Silver Balance",
    //   size: 100,
    //   Cell: (cell) => cell.row.original?.silverBalance,
    // }),
    // columnHelper.accessor("shippingCharges", {
    //   header: "Shipping Charges",
    //   size: 100,
    //   Cell: (cell) => cell.row.original?.shippingCharges,
    // }),

    // columnHelper.accessor("statusCode", {
    //   header: "Status Code",
    //   size: 100,
    //   Cell: (cell) => cell.row.original?.statusCode,
    // }),
    // columnHelper.accessor("message", {
    //   header: "Message",
    //   size: 200,
    //   Cell: (cell) => cell.row.original?.message,
    // }),

    // Status
    // columnHelper.accessor("is_deleted", {
    //   header: "Is Deleted",
    //   size: 100,
    //   Cell: (cell) => (cell.row.original?.is_deleted ? "Yes" : "No"),
    // }),

    // Timestamps
    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 150,
      Cell: (cell) => cell.row.original?.createdAt?.split("T")[0],
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 150,
      Cell: (cell) => cell.row.original?.updatedAt?.split("T")[0],
    }),
    // columnHelper.accessor("Action", {
    //   header: "Action",
    //   size: 150,
    //   Cell: (cell) => (
    //     <Button
    //       onClick={() => {
    //         handleViewStatus(cell.row.original);
    //         setOpen(true);
    //       }}
    //       variant="contained"
    //     >
    //       View Status
    //     </Button>
    //   ),
    // }),
  ];

  return (
    <>
     
       {/* <Filter filterData={filterData} onFilterSubmit={handleFilterSubmit} Onclear={handleClearFilters} page={'augmont_redeem'} setFilterData={setFilterData} /> */}
      <DateSearchComponent onSearch={handleSearch} />
      <Box mt={2}>
        <CustomTable columns={columns} data={sliceResponse} loading={stateLoading} permissionKey="Redeems" />
      </Box>
    </>
  );
}
